export const convertToTitleCase = (string: string) => {
  if (!string || typeof string !== "string") return "";

  return string.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
};
